import { Injectable, Injector } from "@angular/core";

export class AppConstants {
    static AppInjector: Injector;
    static DefaultIcon: string;
}

@Injectable()
export class Configuration {
    public Server = "http://localhost:65425";
    public ApiUrl = "/api/";
    public ServerWithApiUrl = this.ApiUrl;
    // Use this if we ever sepearate the Api from the rest
    // public ServerWithApiUrl = this.Server + this.ApiUrl;

    public ToastrTimeout = 3000;
    public ToastrErrorTimeout = 15000;

    public MaxTextFieldLength = 300;
    public MaxTextAreaLength = 32767;

    public FroalaLicence = "AVB8B-21B4B1E3E3F2D1A16vb2EAJLQCVLUVBd1NXNRSSATEXC-8C2H2C4D5B6B2B1C4A1G2==";

    public static NoOrganizationsSelectedDescription =
        "If no organization is selected, this applies for all organizations";
}
